import React from 'react';
import { SectionEyebrow } from './SectionEyebrow';
import { Reveal } from './Reveal';
import { GridRails } from './GridRails';
import { formulaTerms } from '../data/formula';
const LINE = 'border-blush-line';
// Frame = the vertical page rails; cell padding puts text on the page's content edge
const FRAME = 'mx-auto max-w-[1720px] px-5 md:px-16 lg:px-24';
const LEFT = 'px-4 md:pl-8 md:pr-16';
// Divider sits 32px left of centre so the right cell's text starts exactly at centre
const RIGHT = `px-4 md:-ml-8 md:border-l md:pl-8 md:pr-8 ${LINE}`;
function Rule() {
  return <div aria-hidden="true" className={`relative z-[6] w-full border-t ${LINE}`} data-id="element-192" data-mp="35uuvqkzx37f5" />;
}

/** The core operational formula: z = z² + c — framed by full-width lines that form the cells. */
export function FormulaSection() {
  return <section id="formula" className="relative bg-blush-bg pb-[56px] pt-[56px] text-blush-ink md:pb-[110px] md:pt-[96px]" data-id="element-193" data-mp="1bhllgqzjrhvu">
      <GridRails tone="blush" data-id="element-194" data-mp="1gggc2f3raaqi" />

      <div className="relative z-10" data-id="element-195" data-mp="1ghreoblgtcg1">
        {/* Label row */}
        <div className={FRAME} data-id="element-196" data-mp="1p9wvl2sgi13w">
          <Reveal className={`${LEFT} pb-5`} data-id="element-197" data-mp="1pa5bl3jvlmjb">
            <SectionEyebrow label="THE FORMULA" data-id="element-198" data-mp="1kgkk7ucsfqt3" />
          </Reveal>
        </div>
        <Rule data-id="element-199" data-mp="1fhzkdw1g7956" />

        {/* Formula | statement */}
        <div className={FRAME} data-id="element-200" data-mp="1fiskwf9td2ev">
          <Reveal className="grid md:grid-cols-2" data-id="element-201" data-mp="1ajpm3ckffsfc">
            <div className={`${LEFT} py-8 md:py-16`} data-id="element-202" data-mp="1al0rfgtit88k">
              <p className="flex items-baseline whitespace-nowrap font-editorial text-[68px] italic leading-[0.9] tracking-[-0.04em] sm:text-[120px] lg:text-[150px] xl:text-[190px]" aria-label="z equals z squared plus c" data-id="element-203" data-mp="287q0gamn4l3x">
                <span data-id="element-204" data-mp="1yav1xrqdakpn">z</span>
                <span className="mx-[0.12em]" data-id="element-205" data-mp="1u7yftr1mc6gy">=</span>
                <span data-id="element-206" data-mp="1u75cl01vbz3k">z</span>
                <span className="relative -top-[1.15em] ml-[0.16em] text-[0.4em] leading-none tracking-normal" data-id="element-207" data-mp="mtlk19mw00qg">2</span>
                <span className="mx-[0.12em]" data-id="element-208" data-mp="is0bu1lasaml">+</span>
                <span data-id="element-209" data-mp="iuct0cj8egyl">c</span>
              </p>
            </div>
            <div className={`${RIGHT} flex items-end border-t py-7 md:border-t-0 md:py-16`} data-id="element-210" data-mp="kaqk92vmrk1j">
              <p className="max-w-[440px] font-display text-[22px] leading-[1.2] tracking-[-0.01em] md:text-[26px]" data-id="element-211" data-mp="p7h0bq7fqfmy">
                Quality amplifies quality. One uncompromising principle, applied recursively across every part of the
                ecosystem.
              </p>
            </div>
          </Reveal>
        </div>
        <Rule data-id="element-212" data-mp="1hmp1d2rkz4t" />

        {/* Three terms — cells divided by vertical lines */}
        <div className={FRAME} data-id="element-213" data-mp="6afqns2xrrco">
          <div className="grid md:grid-cols-3" data-id="element-214" data-mp="6bqshmctmp15">
            {formulaTerms.map((t, i) => <Reveal key={t.symbol} delay={i * 0.07} className={`px-4 py-7 md:px-8 md:py-10 ${i > 0 ? `border-t md:border-l md:border-t-0 ${LINE}` : ''}`} data-id="element-215" data-mp="3no1dwmoxb25i" data-mpi={i}>
                <article className="flex h-full flex-col" data-id="element-216" data-mp="3ir1hl3hvldrl">
                  <div className="flex items-baseline justify-between gap-4" data-id="element-217" data-mp="3iqjf3p4me3b8">
                    <h3 className="font-display text-[26px] tracking-[-0.02em] md:text-[30px]" data-id="element-218" data-mp="303sat59c6glc">{t.name}</h3>
                    <span aria-hidden="true" className="font-editorial text-[34px] italic leading-none text-blush-accent" data-id="element-219" data-mp="2v4z8m8zi2c0h">
                      {t.symbol}
                    </span>
                  </div>
                  <p className="mt-2 font-accent text-[11px] uppercase tracking-[0.08em] text-blush-ink/60" data-id="element-220" data-mp="342ssgkg2vd6r">{t.role}</p>
                  <p className="mt-3 max-w-[380px] md:mt-5 text-[14.5px] leading-[1.45] text-blush-ink/70" data-id="element-221" data-mp="3izih34oaxz51">{t.body}</p>
                </article>
              </Reveal>)}
          </div>
        </div>
        <Rule data-id="element-222" data-mp="3rvrg4i8davqn" />
      </div>
    </section>;
}